module.exports = __webpack_public_path__ + "static/bg-night-0bcd50aab68ff7edef50d837ecaa975a.mp4";